import React from "react";

import { ReactComponent as HomepageIcon } from "src/images/menu-icons/homepage.svg";
import { ReactComponent as CompassIcon } from "src/images/compass.svg";
import { ReactComponent as RocketBlueIcon } from "src/images/menu-icons/rocket-blue.svg";
import { ReactComponent as MyTasksIcon } from "src/images/menu-icons/my-tasks.svg";
import { ReactComponent as DataHub } from "src/images/data-hub.svg";
import { ReactComponent as PromoCodesIcon } from "src/images/menu-icons/promo.svg";
import { ReactComponent as CreatorDatabaseIcon } from "src/images/menu-icons/creator-database.svg";
import { ReactComponent as WheelChartIcon } from "src/images/wheel-chart.svg";
import { ReactComponent as StatisticsIcon } from "src/images/menu-icons/statistics.svg";
import { SidebarItem, SidebarItemType } from "src/types";
import CreatorDiscoveryLink from "./CreatorDiscoveryLink/CreatorDiscoveryLink";
import { getIconByPath } from "../../utils/methods";
import { SubscriptionEntitlements } from "../subscription/subscriptionUtils";

export type SidebarElement = {
  icon?: React.ReactNode;
  path?: string | null;
  key: string;
  translateKey?: string;
  defaultMessage?: string;
  overrideHtml?: React.ReactNode;
  subscriptionEntitlement?: SubscriptionEntitlements;
};

export const getSidebarElement = (item: SidebarItem) => {
  switch (item.type) {
    case SidebarItemType.System:
      return sidebarSystemElements.find((el) => el.key === item.key) ?? null;
    case SidebarItemType.Dictionary: {
      if (!item.wsDictionaryShowInSidebar) {
        return null;
      }

      const path = `dict/${item.wsDictionaryUrl}/${item.wsDictionaryUuid}`;
      return {
        icon: getIconByPath(item.wsDictionaryIcon),
        path,
        key: `front_sidebar_item_${item.wsDictionaryUrl}`,
        defaultMessage: item.wsDictionaryName,
      };
    }
    default:
      return null;
  }
};

const sidebarSystemElements: SidebarElement[] = [
  {
    key: "front_sidebar_quick_actions",
  },
  {
    icon: <HomepageIcon />,
    path: "homepage",
    key: "front_sidebar_item_homepage",
    translateKey: "ws_homepage",
    defaultMessage: "Homepage",
  },
  {
    icon: <CompassIcon />,
    path: null,
    key: "front_sidebar_item_creator_discovery",
    translateKey: "ws_discovery",
    defaultMessage: "Discovery",
    overrideHtml: <CreatorDiscoveryLink />,
  },
  {
    icon: <WheelChartIcon />,
    path: "social-insights",
    key: "front_sidebar_item_social_insights",
    translateKey: "ws_social_insights",
    defaultMessage: "Social Insights",
    subscriptionEntitlement: SubscriptionEntitlements.SocialInsights,
  },
  {
    icon: <CreatorDatabaseIcon />,
    path: "creator-database",
    key: "front_sidebar_item_creator_database",
    translateKey: "ws_creator_database",
    defaultMessage: "Creator Database",
  },
  {
    icon: <RocketBlueIcon />,
    path: "projects",
    key: "front_sidebar_item_campaigns",
    translateKey: "ws_campaigns",
    defaultMessage: "Campaigns",
  },
  {
    icon: <PromoCodesIcon />,
    path: "coupon-groups",
    key: "front_sidebar_item_ws_coupons",
    translateKey: "ws_promo_codes",
    defaultMessage: "Promo Codes",
    subscriptionEntitlement: SubscriptionEntitlements.CouponsIntegration,
  },
  {
    icon: <MyTasksIcon />,
    path: "my-actions",
    key: "front_sidebar_item_my_tasks",
    translateKey: "ws_my_tasks",
    defaultMessage: "My tasks",
  },
  {
    icon: <DataHub />,
    path: "summary",
    key: "front_sidebar_item_ws_data_hub",
    translateKey: "ws_data_hub",
    defaultMessage: "Data Hub",
  },
  {
    icon: <StatisticsIcon />,
    path: "reporting",
    key: "front_sidebar_item_finance_reporting",
    defaultMessage: "Finance reporting",
  },
];
